<template>
    <button :class="{active: isActive}" type="button" @click="toggle">
        <slot :is-active="isActive" :toggle="toggle" />
    </button>
</template>

<script>
    import {submitYiiForm} from "../../helpers/yii";

    export default {
        name: 'SubscribeButton',

        props: {
            isInitialActive: { type: Boolean, default: false },
            url: { type: String, required: true },
        },

        data() {
            return {
                isActive: this.isInitialActive,
            };
        },

        methods: {
            async toggle() {
                if (!this.$root.ensurePremium()) {
                    return;
                }

                this.isActive = !this.isActive;
                await submitYiiForm(this.url);
            },
        }
    }
</script>
